import React from 'react';
import '../../entity/entity.scss';
import { render } from 'react-dom';
import { LawyerApp } from './LawyerApp';
import { CustomWindow } from './lawyer.types';

declare let window: CustomWindow;

const target = document.querySelector(`[data-react=doctrine-react]`);
if (target) {
  render(<LawyerApp readKey={window.read_key} />, target);
} else {
  // eslint-disable-next-line no-console
  console.log(`doctrine-react is not visible in the DOM`);
}
